var _path, _path2, _path3, _ellipse, _path4, _rect, _path5, _path6, _ellipse2, _ellipse3, _ellipse4, _path7, _path8, _ellipse5, _path9, _ellipse6, _ellipse7, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _ellipse8, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _circle, _circle2, _path37, _path38, _ellipse9, _path39, _path40, _path41;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlower1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 196,
    viewBox: "0 0 178 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7767 1.44077L38.1571 7.87378L38.2369 8.0894L38.4525 8.16919L44.8855 10.5496L38.4525 12.93L38.2369 13.0098L38.1571 13.2255L35.7767 19.6585L33.3962 13.2255L33.3165 13.0098L33.1008 12.93L26.6678 10.5496L33.1008 8.16919L33.3165 8.0894L33.3962 7.87378L35.7767 1.44077Z",
    fill: "#CCFF90",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.678 140.098L166.537 145.122L171.561 146.981L166.537 148.84L164.678 153.865L162.819 148.84L157.794 146.981L162.819 145.122L164.678 140.098Z",
    fill: "#CCFF90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80623 17.9349L9.44583 22.3659L9.52561 22.5815L9.74123 22.6613L14.1722 24.3009L9.74123 25.9405L9.52561 26.0202L9.44583 26.2359L7.80623 30.6668L6.16663 26.2359L6.08685 26.0202L5.87122 25.9405L1.44028 24.3009L5.87122 22.6613L6.08685 22.5815L6.16663 22.3659L7.80623 17.9349Z",
    fill: "#CCFF90",
    stroke: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.4172,
    cy: 169.926,
    rx: 2.5813,
    ry: 4.01536,
    fill: "#ECEFF1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1921 179.68C72.324 186.564 66.5878 196.889 55.689 192.013C46.511 187.137 38.7633 181.768 38.1931 174.804C41.3479 164.766 55.9753 173.942 61.2004 166.137C64.5796 165.338 76.9365 172.28 75.1921 179.68Z",
    fill: "#ECEFF1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 72.5605,
    y: 124.037,
    width: 19.6972,
    height: 51.0524,
    transform: "rotate(17.9391 72.5605 124.037)",
    fill: "#ECEFF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8366 97.0766C56.8366 101.512 33.8917 109.123 39.0543 105.107C35.6125 112.278 21.272 101.512 21.272 97.0766C23.2797 77.2855 27.8686 92.1993 39.0543 89.0459C48.8752 89.0459 56.8366 92.6414 56.8366 97.0766Z",
    fill: "#ECEFF1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6308 85.7397C31.2038 92.0463 31.0159 98.0865 28.211 99.2309C25.4061 100.375 21.0464 96.1905 18.4734 89.8839C15.9003 83.5773 16.0883 77.5371 18.8932 76.3928C21.6981 75.2484 28.211 74.1307 28.6308 85.7397Z",
    fill: "#ECEFF1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.6906,
    cy: 48.8904,
    rx: 5.44941,
    ry: 11.4724,
    fill: "#ECEFF1"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.0233,
    cy: 50.6111,
    rx: 5.73622,
    ry: 11.4724,
    fill: "#ECEFF1"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.3491,
    cy: 65.8885,
    rx: 5.73622,
    ry: 11.4724,
    transform: "rotate(75.6873 26.3491 65.8885)",
    fill: "#ECEFF1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1247 62.6574C20.1247 67.7262 17.0429 71.8353 13.2413 71.8353C9.43964 71.8353 5.78418 67.7262 5.78418 62.6574C5.78418 57.5885 8.00558 54.3398 11.8072 54.3398C15.6088 54.3398 20.1247 57.5885 20.1247 62.6574Z",
    fill: "#ECEFF1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1376 65.525C28.1376 82.9573 25.1881 84.1905 21.5498 84.1905C17.9114 84.1905 14.9619 75.8337 14.9619 65.525C14.9619 55.2162 17.9114 46.8594 21.5498 46.8594C25.1881 46.8594 28.1376 55.2162 28.1376 65.525Z",
    fill: "#ECEFF1"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.5225,
    cy: 71.4014,
    rx: 1.72087,
    ry: 6.59666,
    transform: "rotate(-26.4991 39.5225 71.4014)",
    fill: "#CCFF90"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8676 69.9869C78.8056 74.1569 67.1829 80.9404 54.5419 86.815C43.3563 93.9853 35.0384 95.1331 31.8835 90.2573C29.9455 86.0872 39.9145 73.072 50.4702 73.0731C63.1112 67.1985 74.9297 65.8168 76.8676 69.9869Z",
    fill: "#CCFF90"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.4801,
    cy: 108.381,
    rx: 9.46477,
    ry: 2.86811,
    transform: "rotate(-18.9975 41.4801 108.381)",
    fill: "#CCFF90"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.8053,
    cy: 104.939,
    rx: 9.46477,
    ry: 2.86811,
    transform: "rotate(-18.9975 51.8053 104.939)",
    fill: "#CCFF90"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2078 113.486C79.2078 120.773 69.1919 126.68 56.8366 126.68C43.6432 129.261 32.7444 116.641 31.5972 108.897C31.5972 101.611 46.5114 118.649 56.8366 100.293C69.1919 100.293 79.2078 106.2 79.2078 113.486Z",
    fill: "#CCFF90"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5408 128.687L96.4166 128.113C96.747 135.319 97.6246 138.552 98.9979 145.896C93.905 147.321 91.2492 147.315 86.665 146.756L91.5408 128.687Z",
    fill: "#CCFF90"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1832 123.976C71.337 130.419 69.8506 136.082 67.6695 136.082C65.4884 136.082 63.7202 130.689 63.7202 124.036C63.7202 117.383 65.4884 111.99 67.6695 111.99C69.8506 111.99 74.7221 118.653 72.1832 123.976Z",
    fill: "#CCFF90"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M131.981 47.5194C127.679 68.4566 123.583 74.4796 104.734 74.4796C85.8839 74.4796 76.7729 62.3707 76.7729 46.3721C76.7729 30.3736 81.6487 16.257 102.012 16.8309C121.229 15.9702 136.857 33.7524 131.981 47.5194Z",
    fill: "#CCFF90"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M161.235 73.9056C156.933 94.8428 139.932 92.2615 121.082 92.2615C102.233 92.2615 108.462 87.8965 108.462 71.8979C108.462 55.8994 114.565 44.6509 133.415 44.6509C153.779 41.2102 162.669 56.697 161.235 73.9056Z",
    fill: "#CCFF90"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M113.052 63.0059C113.052 81.8557 95.331 97.1365 73.4716 97.1365C53.108 94.842 41.9224 83.6563 36.1862 62.1455C30.8835 54.1154 45.5108 25.7207 70.1766 30.0231C91.1138 36.3329 113.052 44.1562 113.052 63.0059Z",
    fill: "#CCFF90"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M153.492 102.014C158.368 119.51 135.423 143.602 117.067 130.695C96.7035 128.401 84.9442 123.525 79.208 102.014C79.208 83.1645 94.6341 68.7441 116.493 68.7441C137.431 75.054 149.19 81.9375 153.492 102.014Z",
    fill: "#CCFF90"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.2537,
    cy: 87.3884,
    rx: 42.4481,
    ry: 41.5876,
    fill: "#FF80AB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6158 124.972C72.5377 124.512 68.1543 138.323 68.1365 138.405C67.9645 139.187 67.7165 139.949 67.4713 140.715C66.876 142.573 66.1512 144.375 65.5565 146.233C63.6573 152.166 61.5571 157.906 59.2284 163.688C58.4612 165.593 57.542 168.406 55.4368 169.287C49.5447 171.754 38.2561 166.046 38.4839 176.456C38.7463 184.065 61.9913 198.722 68.3995 191.075C77.2943 181.058 87.8881 141.001 91.8274 128.55",
    stroke: "black",
    strokeWidth: 1.28599,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7227 128.788C96.7227 147.736 104.74 160.11 105.31 160.859C108.147 164.593 110.356 166.261 114.749 167.853C116.897 168.631 120.498 168.422 122.122 170.236C123.131 171.362 123.297 173.48 123.073 174.904C122.258 180.06 118.911 185.171 123.651 189.464C124.727 190.438 126.164 191.224 127.666 191.15C128.993 191.085 130.216 190.808 131.46 190.324C133.177 189.655 134.752 188.883 136.189 187.724C142.347 182.75 152.043 167.377 146.609 159.402C143.441 154.752 132.101 154.713 127.111 151.613C124.865 150.218 123.193 148.229 122.253 145.812C121.974 145.098 121.702 144.396 121.57 143.641C121.528 143.407 120.062 141.208 115.92 121.742",
    fill: "#ECEFF1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7227 128.788C96.7227 147.736 104.74 160.11 105.31 160.859C108.147 164.593 110.356 166.261 114.749 167.853C116.897 168.631 120.498 168.422 122.122 170.236C123.131 171.362 123.297 173.48 123.073 174.904C122.258 180.06 118.911 185.171 123.651 189.464C124.727 190.438 126.164 191.224 127.666 191.15C128.993 191.085 130.216 190.808 131.46 190.324C133.177 189.655 134.752 188.883 136.189 187.724C142.347 182.75 152.043 167.377 146.609 159.402C143.441 154.752 132.101 154.713 127.111 151.613C124.865 150.218 123.193 148.229 122.253 145.812C121.974 145.098 121.702 144.396 121.57 143.641C121.528 143.407 120.062 141.208 115.92 121.742",
    stroke: "black",
    strokeWidth: 1.28599,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2217 88.7259C33.2999 101.49 26.0934 86.1745 27.5401 71.3262",
    stroke: "black",
    strokeWidth: 1.28599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M133.591 91.7759C133.765 90.2348 133.852 88.6851 133.851 87.1341C133.851 64.2824 114.879 45.7637 91.477 45.7637C68.0752 45.7637 49.1029 64.2824 49.1029 87.1341C49.1029 109.986 68.0752 128.505 91.477 128.505C99.4512 128.549 107.277 126.346 114.057 122.149C120.738 118.014 125.774 112.493 129.285 105.487",
    stroke: "black",
    strokeWidth: 1.28599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1958 84.211C74.4763 84.211 73.893 83.6278 73.893 82.9082C73.893 82.1887 74.4763 81.6055 75.1958 81.6055C75.9153 81.6055 76.4985 82.1887 76.4985 82.9082C76.4985 83.6278 75.9153 84.211 75.1958 84.211Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.28599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M87.645 85.1017C86.9255 85.1017 86.3422 84.5184 86.3422 83.7989C86.3422 83.0794 86.9255 82.4961 87.645 82.4961C88.3645 82.4961 88.9478 83.0794 88.9478 83.7989C88.9478 84.5184 88.3645 85.1017 87.645 85.1017Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.28599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7592 89.1719C76.9908 96.9692 84.7206 95.1261 85.0005 89.6061",
    stroke: "black",
    strokeWidth: 1.28599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0263 60.2821C30.1073 60.45 28.2132 60.8331 26.3798 61.4242C23.1911 62.3379 21.4186 64.7317 21.1445 66.5042C20.9379 67.3724 21.0458 68.2858 21.4489 69.082C21.8521 69.8782 22.5244 70.5058 23.3464 70.8533C25.859 71.9497 33.5978 69.8482 34.9957 68.6696C37.1702 66.8422 38.824 59.8253 31.341 60.3004",
    stroke: "black",
    strokeWidth: 1.28599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3403 100.815C49.8236 104.588 36.6303 107.393 35.6709 107.211C31.8061 107.503 18.101 106.151 15.5702 72.0799C15.5702 72.0799 8.10547 73.5692 6.07712 63.2447C4.04877 52.9203 13.2129 54.5192 13.2129 54.5192C13.2129 54.5192 12.016 37.2874 18.2838 37.2326C24.5515 37.1777 24.1312 53.7426 24.1312 53.7426C24.1312 53.7426 25.383 37.1412 31.8335 38.6579C38.284 40.1746 35.8079 54.3365 35.8079 54.3365L34.4466 60.3941",
    stroke: "black",
    strokeWidth: 1.28599,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2257 54.0848C12.0102 54.367 12.0642 54.7705 12.3464 54.9861C14.276 56.4599 15.5923 58.8158 16.4761 61.1614C17.3553 63.4949 17.7787 65.7425 17.9676 66.9205L17.9685 66.9262L17.9685 66.9262C18.1005 67.7048 18.0136 68.5047 17.7176 69.2368C17.4143 69.9268 16.9101 70.5096 16.2708 70.909C15.629 71.3099 14.8811 71.5074 14.1251 71.4756C13.7703 71.4607 13.4706 71.7362 13.4557 72.091C13.4407 72.4458 13.7162 72.7455 14.071 72.7604C15.0861 72.8032 16.0904 72.538 16.9521 71.9997C17.8138 71.4614 18.4925 70.6751 18.8993 69.7441L18.9026 69.7365L18.9057 69.7288C19.2939 68.7742 19.4086 67.7303 19.2369 66.7142C19.0418 65.4976 18.6018 63.1557 17.6795 60.708C16.7611 58.2706 15.3364 55.6516 13.127 53.9641C12.8448 53.7485 12.4413 53.8026 12.2257 54.0848Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M149.708 90.1009C149.499 89.8146 149.097 89.7525 148.81 89.9622C148.524 90.1718 148.462 90.5738 148.672 90.8601L149.708 90.1009ZM118.265 133.015C124.618 135.527 131.857 134.945 138.098 132.172C144.339 129.399 149.642 124.407 152.093 118.018L150.893 117.558C148.584 123.578 143.558 128.34 137.576 130.998C131.594 133.656 124.717 134.184 118.737 131.82L118.265 133.015ZM154.402 105.239C154.38 105.151 154.363 104.975 154.351 104.659C154.34 104.346 154.337 103.996 154.324 103.531C154.299 102.632 154.239 101.466 154.016 100.103C153.568 97.3707 152.468 93.8694 149.708 90.1009L148.672 90.8601C151.296 94.443 152.328 97.7484 152.748 100.31C152.958 101.594 153.015 102.697 153.04 103.567C153.051 103.988 153.056 104.398 153.067 104.705C153.078 105.008 153.096 105.313 153.156 105.551L154.402 105.239Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0361 146.801C89.9437 147.552 94.7337 147.422 98.3576 145.662",
    stroke: "black",
    strokeWidth: 1.28491,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1592 106.73C34.4725 122.572 46.1728 130.131 63.6754 125.989C63.5743 130.077 65.441 134.138 68.5959 136.72",
    stroke: "black",
    strokeWidth: 1.28491,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M149.19 90.48C172.28 82.1967 162.339 37.4386 132.576 44.8511C137.323 17.027 85.8055 4.37923 77.9207 32.8938C55.6905 21.3246 35.8255 41.1787 34.8656 60.632M35.7004 68.1906C36.5441 71.1508 38.0262 73.9853 40.24 76.565C35.4915 80.4894 32.9114 84.801 31.5977 89.6196",
    stroke: "black",
    strokeWidth: 1.28491,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M139.73 118.75L129.923 112.242",
    stroke: "black",
    strokeWidth: 1.28491,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3389 107.168L39.6275 112.157",
    stroke: "black",
    strokeWidth: 1.12144,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M135.422 68.7446L146.321 63.582",
    stroke: "black",
    strokeWidth: 1.28491,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M104.869 41.3193L108.236 29.7391",
    stroke: "black",
    strokeWidth: 1.28491,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0791 52.4243L51.6739 42.9059",
    stroke: "black",
    strokeWidth: 1.28491,
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66.0146,
    cy: 86.5283,
    r: 2.86811,
    fill: "#CCFF90"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96.9902,
    cy: 88.8212,
    r: 2.86811,
    fill: "#CCFF90"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3247 124.617C79.1483 127.137 83.7081 128.055 91.2542 128.346L88.0996 138.958C87.7276 133.192 80.9592 128.281 72.3247 124.617Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1299 128.473C103.405 127.754 108.749 124.433 115.346 121.462L118.788 135.516C116.571 130.319 103.295 128.416 96.1299 128.473Z",
    fill: "black"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.244,
    cy: 93.1228,
    rx: 4.58898,
    ry: 7.7439,
    fill: "#ECEFF1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M127.048 85.3955C128.456 87.0928 129.951 88.7162 131.527 90.2593C140.527 99.2184 161.762 116.307 183.097 103.93C185.504 102.545 188.699 103.87 190.054 106.964C192.077 111.514 191.632 117.996 176.909 121.869C176.757 121.922 176.632 122.031 176.558 122.174C176.485 122.317 176.469 122.483 176.515 122.637C176.98 125.135 177.971 133.76 166.737 124.468C166.371 124.162 165.958 123.92 165.513 123.75C161.398 122.223 138.474 113.476 127.553 103.89C126.4 102.898 125.335 101.808 124.368 100.634",
    fill: "#ECEFF1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M127.048 85.3955C128.456 87.0928 129.951 88.7162 131.527 90.2593C140.527 99.2184 161.762 116.307 183.097 103.93C185.504 102.545 188.699 103.87 190.054 106.964C192.077 111.514 191.632 117.996 176.909 121.869C176.757 121.922 176.632 122.031 176.558 122.174C176.485 122.317 176.469 122.483 176.515 122.637C176.98 125.135 177.971 133.76 166.737 124.468C166.371 124.162 165.958 123.92 165.513 123.75C161.398 122.223 138.474 113.476 127.553 103.89C126.4 102.898 125.335 101.808 124.368 100.634C119.362 93.9847 123.951 82.512 127.048 85.3955Z",
    stroke: "black",
    strokeWidth: 1.28599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2399 97.6523L51.3871 101.094C47.4233 104.431 42.1098 106.31 36.7598 106.543C45.9377 103.389 49.3795 99.3732 50.2399 97.6523Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower1);
export default __webpack_public_path__ + "static/media/Flower1.175ace630bc962c3dd43097b89726ae8.svg";
export { ForwardRef as ReactComponent };